<!--
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2023-06-16 11:51:23
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-16 14:37:37
 * @FilePath: /notion-widgets-site/src/components/home/FooterActions.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="actions">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="12">
        <el-popover placement="top" width="450" trigger="hover">
          <div class="reward">
            <img src="../../assets/reward.jpg" alt="" />
            <img src="../../assets/reward-alipay.jpg" alt="" />
          </div>
          <div class="action-item" slot="reference">
            <el-avatar class="btn" :size="47">赏</el-avatar>
            <p>打赏</p>
          </div>
        </el-popover>
      </el-col>
      <!-- <el-col :span="12">
        <a href="#" rel="sidebar" class="action-item" @click="addFav()">
          <el-avatar class="btn" :size="47" icon="el-icon-star-on"></el-avatar>
          <p>收藏</p>
        </a>
      </el-col> -->
    </el-row>
  </div>
</template>
<script>
export default {
  methods: {
  },
};
</script>
<style lang="less" scoped>
.action-item {
  cursor: pointer;
  display: inline-block;
  .btn {
    background-color: #fff;
    color: #818797;
    font-size: 20px;
    box-shadow: 0 8px 16px 0 rgba(23, 35, 63, 0.04);
    border: 1px solid #f4f4f4;
  }
  &:hover {
    .btn {
      box-shadow: 0 8px 16px 0 rgba(23, 35, 63, 0.12);
    }
  }
}
.reward {
  display: flex;
  justify-content: space-around;
  img {
    width: 200px;
    height: 200px;
    display: inline-block;
  }
}

.row-bg {
  width: 500px;
  margin: 0 auto;
}
</style>
